import { render, staticRenderFns } from "./BlockedIP.vue?vue&type=template&id=71da1e44&scoped=true"
import script from "./BlockedIP.vue?vue&type=script&lang=js"
export * from "./BlockedIP.vue?vue&type=script&lang=js"
import style0 from "./BlockedIP.vue?vue&type=style&index=0&id=71da1e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71da1e44",
  null
  
)

export default component.exports